var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_713",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 56,
    height: 57
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.9999 55.9919C43.4639 55.9919 55.9999 43.4559 55.9999 27.9919C55.9999 12.528 43.4639 -0.00805664 27.9999 -0.00805664C12.536 -0.00805664 -6.10352e-05 12.528 -6.10352e-05 27.9919C-6.10352e-05 43.4559 12.536 55.9919 27.9999 55.9919Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M4.45428 -0.00805664V34.3556H16.9907L27.9997 15.2647H55.9997V-0.00805664H4.45428Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c_2",
    d: "M4.45428 -0.00805664V34.3556H16.9907L27.9997 15.2647H55.9997V-0.00805664H4.45428Z",
    fill: "url(#paint0_linear_2757_713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M-0.00012207 55.9919H26.6635L39.0726 43.5829V34.3556H16.9272L-0.00012207 5.24194V55.9919Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e_2",
    d: "M-0.00012207 55.9919H26.6635L39.0726 43.5829V34.3556H16.9272L-0.00012207 5.24194V55.9919Z",
    fill: "url(#paint1_linear_2757_713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M27.9999 15.2644L39.009 34.3553L26.7272 55.9917H55.9999V15.2644H27.9999Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g_2",
    d: "M27.9999 15.2644L39.009 34.3553L26.7272 55.9917H55.9999V15.2644H27.9999Z",
    fill: "url(#paint2_linear_2757_713)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.277 34.2598L4.45428 12.8462L16.8634 34.4189L17.277 34.2598Z",
    fill: "#3E2723",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.7543 34.7689L38.4998 34.6416L26.6316 55.9598L38.818 34.6416L38.7543 34.7689Z",
    fill: "#263238",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.9999 15.2644V21.9462L52.9454 15.2644H27.9999Z",
    fill: "url(#paint3_radial_2757_713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.45428 12.8784L22.6543 31.0784L16.9907 34.3557L4.45428 12.8784Z",
    fill: "url(#paint4_radial_2757_713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.6635 55.9925L33.3453 31.0789L39.0089 34.3561L26.6635 55.9925Z",
    fill: "url(#paint5_radial_2757_713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28 40.719C35.0291 40.719 40.7272 35.0208 40.7272 27.9917C40.7272 20.9626 35.0291 15.2644 28 15.2644C20.9709 15.2644 15.2727 20.9626 15.2727 27.9917C15.2727 35.0208 20.9709 40.719 28 40.719Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.9999 38.1739C33.6231 38.1739 38.1817 33.6154 38.1817 27.9921C38.1817 22.3689 33.6231 17.8103 27.9999 17.8103C22.3766 17.8103 17.8181 22.3689 17.8181 27.9921C17.8181 33.6154 22.3766 38.1739 27.9999 38.1739Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M27.9999 55.9919C43.4639 55.9919 55.9999 43.4559 55.9999 27.9919C55.9999 12.528 43.4639 -0.00805664 27.9999 -0.00805664C12.536 -0.00805664 -6.10352e-05 12.528 -6.10352e-05 27.9919C-6.10352e-05 43.4559 12.536 55.9919 27.9999 55.9919Z",
    fill: "url(#paint6_radial_2757_713)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39.009 34.356C37.8902 36.2847 36.2843 37.8856 34.3522 38.9985C32.4201 40.1113 30.2296 40.6971 27.9999 40.6971C25.7702 40.6971 23.5796 40.1113 21.6475 38.9985C19.7154 37.8856 18.1096 36.2847 16.9908 34.356L-0.00012207 5.56055L16.9908 34.6742C18.1096 36.6029 19.7154 38.2038 21.6475 39.3167C23.5796 40.4295 25.7702 41.0153 27.9999 41.0153C30.2296 41.0153 32.4201 40.4295 34.3522 39.3167C36.2843 38.2038 37.8902 36.6029 39.009 34.6742V34.356Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M28.3181 15.2644H28.159C31.5345 15.2644 34.7717 16.6053 37.1585 18.9921C39.5453 21.379 40.8862 24.6162 40.8862 27.9917C40.8862 31.3672 39.5453 34.6044 37.1585 36.9912C34.7717 39.378 31.5345 40.719 28.159 40.719H28.3181C35.3181 40.719 41.0453 34.9917 41.0453 27.9917C41.0453 20.9917 35.3181 15.2644 28.3181 15.2644ZM27.9999 55.6735C35.3985 55.6736 42.4964 52.7455 47.7428 47.5288C52.9893 42.3122 55.9578 35.231 55.9999 27.8326V27.9917C55.9999 35.4177 53.0499 42.5397 47.7989 47.7907C42.5479 53.0417 35.4259 55.9917 27.9999 55.9917C20.5738 55.9917 13.4519 53.0417 8.20089 47.7907C2.94987 42.5397 -0.00012207 35.4177 -0.00012207 27.9917V27.8326C0.0419153 35.231 3.01045 42.3122 8.25692 47.5288C13.5034 52.7455 20.6013 55.6736 27.9999 55.6735Z",
    fill: "#3E2723",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M39.1363 34.7697C40.0249 33.245 40.5807 31.5495 40.7671 29.7946C40.9536 28.0397 40.7665 26.2653 40.2181 24.5879C40.7128 26.2098 40.8608 27.9177 40.6525 29.6006C40.4442 31.2835 39.8843 32.9037 39.009 34.3561L27.0454 55.9924L39.1999 34.8333L39.1363 34.7697ZM27.9999 0.310613C35.3985 0.310494 42.4964 3.23864 47.7429 8.4553C52.9894 13.672 55.9579 20.7531 55.9999 28.1515V27.9924C55.9999 20.5664 53.0499 13.4445 47.7989 8.19344C42.5479 2.94242 35.426 -0.00756836 27.9999 -0.00756836C20.5739 -0.00756836 13.452 2.94242 8.20095 8.19344C2.94993 13.4445 -6.10352e-05 20.5664 -6.10352e-05 27.9924V28.1515C0.0419763 20.7531 3.01052 13.672 8.25698 8.4553C13.5035 3.23864 20.6014 0.310494 27.9999 0.310613Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M28 14.9468C21 14.9468 15.2727 20.674 15.2727 27.674V27.9922C15.2727 20.9922 21 15.265 28 15.265H56V14.9468H28Z",
    fill: "#3E2723",
    fillOpacity: 0.2
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_713",
    x1: 6.77701,
    y1: 21.6283,
    x2: 23.4816,
    y2: 11.8919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2757_713",
    x1: 32.7408,
    y1: 50.1056,
    x2: 14.159,
    y2: 39.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2757_713",
    x1: 36.559,
    y1: 13.6099,
    x2: 41.2363,
    y2: 34.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2757_713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7908 15.2644) scale(26.7591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2757_713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.42247 12.8784) scale(24.8182 24.8182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2757_713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9362 28.0243) scale(27.9682 27.9682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2757_713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.36812 7.62831) scale(56.2545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/Chrome.82f110f8ce3fdfbe13c8084d76d8758e.svg";
export { ForwardRef as ReactComponent };